export function isTextOverflowing(element: HTMLElement) {
  const contentHeight = element.scrollHeight;
  const elementHeight = element.clientHeight;

  return contentHeight > elementHeight;
}
